"use strict";

export function initInScope($scope) {
    $scope.find('.js-expandable').each(function () {
        let expandableElement = $(this);
        let expandableContent = expandableElement.find('.js-expandable__content');
        let expandableHeight = expandableElement.data('expandable-height') || 350;
        let expandableAnchor = expandableElement.data('expandable-anchor');
        let expandableMoreHeight = expandableElement.find(".js-expandable__more").height() + 40;
        if(expandableAnchor) {
            let expandableAnchorEl = $(expandableAnchor);
            if(expandableAnchorEl.length > 0) {
                expandableHeight = expandableAnchorEl.get(0).scrollHeight;
            }
        }

        let expandableInitHeight = expandableContent.height() + expandableMoreHeight;
        // console.log("expandableInitHeight");
        // console.log(expandableInitHeight);
        // console.log("expandableHeight");
        // console.log(expandableHeight);
        if (expandableInitHeight > expandableHeight) {
            expandableElement.addClass('is-expandable');
            expandableElement.css("height", expandableHeight + "px");
            expandableElement.find('.js-expandable__more').on('click', function (evt) {
                evt.preventDefault();

                if (expandableElement.hasClass('is-collapsed')) {
                    expandableElement.removeClass('is-collapsed');
                    expandableElement.animate({
                        height: expandableInitHeight + "px"
                    }, 300);
                } else {
                    expandableElement.addClass('is-collapsed');
                    expandableElement.animate({
                        height: expandableHeight + "px"
                    }, 300);
                }
            });
        } else {
            expandableElement.addClass('is-not-expandable');
        }
    });
}